export default "__VITE_ASSET__Cv9Va3vg__"